import { render, staticRenderFns } from "./DeviceSettings.vue?vue&type=template&id=a87cd814&scoped=true&"
import script from "./DeviceSettings.vue?vue&type=script&lang=ts&"
export * from "./DeviceSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87cd814",
  null
  
)

export default component.exports